import { useState, useEffect } from "react";
import { Card, Col, Row, Typography, Table, Tag, Avatar, Progress } from "antd";
import { Link } from 'react-router-dom';
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import moment from 'moment';
import apiPath from "../../constants/apiPath";
import { BookOpen, Boxes, Building, Building2, Car, Copyright, Flag, FolderTree, Globe, Layers, List, Package, UsersRoundIcon } from "lucide-react";
const { Title } = Typography;

function Home() {

  const { request }                   =   useRequest();
  const [loading, setLoading]         =   useState(false);
  const [recentUser, setRecentUser]   =   useState([]);
  const [dashboard, setDashboard]     =   useState({});

  const userColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 200,
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (_, { name }) => {
        return (
          <>
            <Avatar className="cap" size={40}> {name?.charAt(0)} </Avatar>
            <a style={{ marginLeft: 12 }} className="cap avatar-text">{name}</a>
          </>
        );
      },
    },
    {
      title: "Mobile Number",
      render: (_, { phone, country_code }) => {
        return (
          (country_code ? "+" + country_code + "-" : "+91") + (phone ? phone : '')
        );
      },
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",
      width: 250,
      sorter: (a, b) => a.email.localeCompare(b.email),
      render: (_, { email }) => {
        return email ? email : '-';
      },
    },
    {
      title: "Status",
      key: "is_active",
      render: (_, { is_active }) => {
        let color = is_active ? 'green' : 'red';
        return (<Tag color={color} key={is_active}>{is_active ? "Active" : "Inactive"}</Tag>);
      },
    },
    {
      title: "Registered On",
      key: "created_at",
      dataIndex: "created_at",
      sorter: (a, b) => a.created_at.localeCompare(b.created_at),
      render: (_, { created_at }) => {
        return (
          moment(created_at).format('DD-MMM-YYYY')
        );
      },
    },
  ];

  const count = [
    {
      title: "Active & Total User",
      count: `${dashboard && dashboard.activeUserCount || 0} & ${dashboard && dashboard.userCount || 0}`,
      totalCount: `${dashboard && dashboard.userCount || 0}`,
      icon: <UsersRoundIcon size={18} />,
      url: '/user'
    },
    {
      title: "Active & Total Brand",
      count: `${dashboard && dashboard.activeBrandCount || 0} & ${dashboard && dashboard.brandCount || 0}`,
      totalCount: `${dashboard && dashboard.brandCount || 0}`,
      icon: <Copyright size={18} />,
      url: '/brand'
    },
    {
      title: "Active & Total Manufacturer",
      count: `${dashboard && dashboard.activeVehicleManufacturerCount || 0} & ${dashboard && dashboard.vehicleManufacturerCount || 0}`,
      totalCount: `${dashboard && dashboard.vehicleManufacturerCount || 0}`,
      icon: <Building2 size={18} />,
      url: '/vehicle-manufacturer'
    },
    {
      title: "Active & Total Vehicle",
      count: `${dashboard && dashboard.activeVehicleCount || 0} & ${dashboard && dashboard.vehicleCount || 0}`,
      totalCount: `${dashboard && dashboard.vehicleCount || 0}`,
      icon: <Car size={18} />,
      url: '/vehicle'
    },
    {
      title: "Active & Total Vehicle Model",
      count: `${dashboard && dashboard.activeVehicleModelCount || 0} & ${dashboard && dashboard.vehicleModelCount || 0}`,
      totalCount: `${dashboard && dashboard.vehicleModelCount || 0}`,
      icon: <Boxes size={18} />,
      url: '/vehicle-model'
    },
    {
      title: "Active & Total Category",
      count: `${dashboard && dashboard.activeCategoryCount || 0} & ${dashboard && dashboard.categoryCount || 0}`,
      totalCount: `${dashboard && dashboard.categoryCount || 0}`,
      icon: <List size={18} />,
      url: '/category'
    },
    {
      title: "Active & Total Sub Category",
      count: `${dashboard && dashboard.activeSubCategoryCount || 0} & ${dashboard && dashboard.subCategoryCount || 0}`,
      totalCount: `${dashboard && dashboard.subCategoryCount || 0}`,
      icon: <Layers size={18} />,
      url: '/sub-category'
    },
    {
      title: "Active & Total Scheme",
      count: `${dashboard && dashboard.activeSchemeCount || 0} & ${dashboard && dashboard.schemeCount || 0}`,
      totalCount: `${dashboard && dashboard.schemeCount || 0}`,
      icon: <FolderTree size={18} />,
      url: '/schemes'
    },
    {
      title: "Active & Total Segment",
      count: `${dashboard && dashboard.activeSegmentCount || 0} & ${dashboard && dashboard.segmentCount || 0}`,
      totalCount: `${dashboard && dashboard.segmentCount || 0}`,
      icon: <Globe size={18} />,
      url: '/segment'
    },
    {
      title: "Active & Total Product",
      count: `${dashboard && dashboard.activeProductCount || 0} & ${dashboard && dashboard.productCount || 0}`,
      totalCount: `${dashboard && dashboard.productCount || 0}`,
      icon: <Package size={18} />,
      url: '/product'
    },
    {
      title: "Active & Total Catalogue",
      count: `${dashboard && dashboard.activeCatalogueCount || 0} & ${dashboard && dashboard.catalogueCount || 0}`,
      totalCount: `${dashboard && dashboard.catalogueCount || 0}`,
      icon: <BookOpen size={18} />,
      url: '/catalogue'
    },
    {
      title: "Active & Total State",
      count: `${dashboard && dashboard.activeStateCount || 0} & ${dashboard && dashboard.stateCount || 0}`,
      totalCount: `${dashboard && dashboard.stateCount || 0}`,
      icon: <Flag size={18} />,
      url: '/state'
    },
    {
      title: "Active & Total City",
      count: `${dashboard && dashboard.activeCityCount || 0} & ${dashboard && dashboard.cityCount || 0}`,
      totalCount: `${dashboard && dashboard.cityCount || 0}`,
      icon: <Building size={18} />,
      url: '/city'
    },
  ];

  useEffect(() => {
    setLoading(true)
    request({
      url: apiPath.dashboard, 
      method: 'POST',
      onSuccess: (data) => {
        setLoading(false)
        setDashboard(data.data);
        setRecentUser(data.data.recentUsers);
      },
      onError: (error) => {
        setLoading(false)
        ShowToast(error, Severty.ERROR)
      }
    })
  }, [])
 
  const maxValue = Math.max(...count.map((c) => c.totalCount || 0)) || 1;

  return (
    <>
      <div className="layout-content">
        
        <div className="mb-24">
          <Row gutter={[24, 0]}>
            <Col xs={24} sm={18} md={24}>
              <Row className="rowgap-vbox" gutter={[24, 16]}>
                {count.map((c, index) => {
                  const percentage = Math.round((c.totalCount / maxValue) * 100);

                  return (
                    <Col key={index} xs={24} sm={24} md={12} lg={12} xl={8} xxl={6}>
                      <Link to={c.url}>
                        <Card className="criclebox hover:shadow-md transition">
                          <div className="number">
                            <Row align="middle" gutter={[16, 0]}>
                              
                              <Col xs={18}>
                                
                                <Title level={5} style={{ margin: 0 }}> {c.title} </Title>

                                <span style={{ fontSize: 20, fontWeight: 600 }}> {c.count} </span>

                                <Progress
                                  percent={percentage}
                                  showInfo={false}
                                  strokeColor={{
                                    '0%': '#108ee9',
                                    '100%': '#87d068',
                                  }}
                                  size="small"
                                />
                              </Col>

                              <Col xs={6}>
                                <div className="icon-box flex justify-center items-center rounded-full bg-blue-50 mb-5">
                                  {c.icon}
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Card>
                      </Link>
                    </Col>
                  );
                })}
              </Row>
            </Col>
          </Row>
        </div>

        <Row gutter={[24, 16]}>
          <Col span={24} xs={24} sm={24} md={24}>
            <Card variant={true} className="criclebox tablespace">
              <div className="mb-3 font-medium text-lg">Latest Registered User (10)</div>
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={userColumns}
                  dataSource={recentUser}
                  pagination={false}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Home;
